<template>
  <v-card elevation="0">
    <v-row style="width: 95%" class="ml-2 mt-1">
      <v-col cols="10" style="padding: 0px 20px">
        <v-autocomplete
          label="Group"
          v-model="target.groupId"
          :items="groupList"
          item-text="name"
          item-value="identity"
          style="padding: 0px"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="3" style="padding: 0px 20px">
        <v-checkbox
          label="All Dates"
          v-model="target.isAll"
          style="padding: 0px; margin: 20px 0px"
        ></v-checkbox>
      </v-col>
      <v-col
        v-if="!target.isAll"
        cols="12"
        lg="4"
        md="4"
        sm="4"
        style="padding: 0px 20px"
      >
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="target.start"
              label="Start Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="target.start"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        v-if="!target.isAll"
        cols="12"
        lg="4"
        md="4"
        sm="4"
        style="padding: 0px 20px"
      >
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="target.end"
              label="End Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="target.end"
            @input="menu2 = false"
            :min="target.start"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <div style="text-align: left" class="ml-7">Methods:</div>
    <v-row style="width: 95%" class="ml-2 mt-2">
      <v-col cols="12" lg="3" md="3" sm="3" style="padding: 0px 20px">
        <v-checkbox
          label="Subscribe"
          v-model="target.canSubscribe"
          style="padding: 0px; margin: 0px"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="3" style="padding: 0px 20px">
        <v-checkbox
          label="Push"
          v-model="target.canPush"
          style="padding: 0px; margin: 0px"
          disabled
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save" small outlined class="mr-2"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalendarPublisherIntegratedEditor",
  props: { isShow: Boolean, target: Object },
  computed: {
    ...mapGetters(["groupList"]),
  },
  data: () => {
    return {
      title: "Add Target",
      groups: [
        { identity: "Staff", name: "Staff" },
        { identity: "Students", name: "Students" },
      ],
      menu1: false,
      menu2: false,
      //target: { identity:'', groups: [], isAll: true, canSubscribe: true, canPush: true }
    };
  },
  methods: {
    close() {
      //this.target = { identity:'', groups: [], isAll: true, start:'', end:'', canSubscribe: true, canPush: true };
      this.$emit("close", "close");
    },
    save() {
      //if (this.target.groups.length > 0) 
      if (this.target.groupId)  
        this.$emit("save", this.target);
      else
        alert('Please choose target group')
    },
  },
  async mounted() {
    if (!this.groupList) await this.$store.dispatch("getGroupList");
  },
};
</script>

<style>
.v-data-footer{
  padding-left: 0px;
}
.v-data-footer__pagination{
  margin-left: 10px!important;
  margin-right: 10px!important;
}
</style>